angular.module('impactx.search').component('ixTenderList', {
        bindings: {
            tenders: '<',
            trns: '<',
        },
        require: {
            containerCtrl: '^^ixListTabContainer'
        },
        controller: 'TenderSearchListCtrl',
        controllerAs: 'tenderSearchListCtrl',
        templateUrl: 'modules/search/templates/tender-list.html'
    }
);
